import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const FALLBACK_IMAGE = '/fallback.png';

const ArticleCard = ({ article }) => {
  const [imageSrc, setImageSrc] = useState(article.cover_image?.trim() || FALLBACK_IMAGE);
  const formattedDate = new Date(article.created_at).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const category = article.category || null;

  return (
    <article className="group flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
      <div className="relative h-48 overflow-hidden bg-gray-100">
        <img
          src={imageSrc}
          alt={article.title}
          onError={() => setImageSrc(FALLBACK_IMAGE)}
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-white/90 backdrop-blur-sm text-xs font-semibold px-3 py-1 rounded-full" style={{ color: 'var(--brand-primary)' }}>
            {category?.name || 'Education'}
          </span>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-grow">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs text-gray-500">{formattedDate}</span>
          {article.author_name && (
            <>
              <span className="text-gray-300 text-xs">·</span>
              <span className="text-xs text-gray-500">{article.author_name}</span>
            </>
          )}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-indigo-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-gray-600 text-sm line-clamp-3 mb-6 flex-grow">
          {article.summary}
        </p>
        <Link
          to={`/blog/${article.slug}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-semibold transition-colors mt-auto"
          style={{ color: 'var(--brand-primary)' }}
        >
          Read Article <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
};

export default ArticleCard;